import {Box, Button, Typography} from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import {makeStyles} from '@material-ui/core/styles';
import {Alert} from '@material-ui/lab';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import 'Users/components/UserAccount/SwitchTaxIdModal.sass';
import {ReducerState} from '../../rootReducer';
import {isSchooxPopupClosedEvent, redirectSchoox, toggleSchooxConfirmation} from '../ducks/schoox';

export const useSchooxStyles = makeStyles(theme => ({
  snackBar: {
    boxShadow: '6px 10px 0px -1px rgba(230, 223, 230, 0.5)',
    borderRadius: 0,
    textAlign: 'justify',
    top: '50%',
    backgroundColor: 'transparent',
    margin: '0 1.5rem 0 .8rem',
    right: 0,
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('md')]: {
      width: '65%',
    },

    [theme.breakpoints.down('xs')]: {
      top: '40%',
      transform: 'translate(0%, 0%)',
      width: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  },

  alertInfo: {
    padding: '1.25rem 1.35rem',
    display: 'flex',
    color: 'rgba(0, 0, 0, 0.87)',
    alignItems: 'flex-start',
    marginBottom: '0px',
    borderRadius: 0,
    width: '100%',
    backgroundColor: '#EDF6FC',
    '& .MuiAlert-icon': {
      color: '#2196F3',
    },
  },
  alertSuccess: {
    '& .MuiAlert-icon': {
      color: '#4CAF50',
    },
  },
  alertError: {
    '& .MuiAlert-icon': {
      color: '#F44336',
    },
  },
}));

const useEllipseStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '.5rem 0',
    overflow: 'hidden',
  },
  ellipse: {
    position: 'relative',
    left: '-9999px',
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    backgroundColor: '#0033A0',
    color: '#0033A0',
    boxShadow: '9999px 0 0 -5px',
    animation: '$ellipse 1.5s infinite linear',
    animationDelay: '0.25s',
    '&::before, &::after': {
      content: '""',
      display: 'inline-block',
      position: 'absolute',
      top: '0',
      width: '10px',
      height: '10px',
      borderRadius: '5px',
      backgroundColor: '#0033A0',
      color: '#0033A0',
    },

    '&::before': {
      boxShadow: '9984px 0 0 -5px',
      animation: '$ellipseBefore 1.5s infinite linear',
      animationDelay: '0s',
    },
    '&::after': {
      boxShadow: '10014px 0 0 -5px',
      animation: '$ellipseAfter 1.5s infinite linear',
      animationDelay: '0.5s',
    },
  },

  '@keyframes ellipseBefore': {
    '0%': {
      boxShadow: '9984px 0 0 -5px',
    },
    '30%': {
      boxShadow: '9984px 0 0 2px',
    },
    '60%, 100%': {
      boxShadow: '9984px 0 0 -5px',
    },
  },
  '@keyframes ellipse': {
    '0%': {
      boxShadow: '9999px 0 0 -5px',
    },
    '30%': {
      boxShadow: '9999px 0 0 2px',
    },
    '60%, 100%': {
      boxShadow: '9999px 0 0 -5px',
    },
  },
  '@keyframes ellipseAfter': {
    '0%': {
      boxShadow: '10014px 0 0 -5px',
    },
    '30%': {
      boxShadow: '10014px 0 0 2px',
    },
    '60%, 100%': {
      boxShadow: '10014px 0 0 -5px',
    },
  },
}));

const schooxMsgStyles: React.CSSProperties = {position: 'relative', top: '-0.25rem', fontSize: '1.15rem'};

export const Schoox = () => {
  const {isSchooxConfirmationOpen, isLoading, schooxUser, isSynced} = useSelector((state: ReducerState) => state.schoox);
  const classes = useSchooxStyles();
  const dispatch = useDispatch();
  const syncError = schooxUser?.totalIds === 0 || !schooxUser?.isSyncedWithSchooxSource;
  const alertStyles = isLoading
    ? `${classes.alertInfo}`
    : syncError
    ? `${classes.alertInfo} ${classes.alertError}`
    : `${classes.alertInfo} ${classes.alertSuccess} `;

  const alertSeverity = isLoading ? 'info' : syncError ? 'error' : 'success';

  const handleToggleOnCloseSchooxPopup = () => {
    dispatch(toggleSchooxConfirmation(false));
    dispatch(isSchooxPopupClosedEvent(true));
  };

  const handleToggleOnGoToTrainingSchooxPopup = () => {
    dispatch(redirectSchoox());
    dispatch(isSchooxPopupClosedEvent(true));
  };

  return (
    <Snackbar
      key={`snackbar_Schoox_loading`}
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      className={classes.snackBar}
      open={isSchooxConfirmationOpen}
    >
      <Alert
        severity={alertSeverity}
        variant="filled"
        className={alertStyles}
        onClose={() => handleToggleOnCloseSchooxPopup()}
      >
        <Box style={{display: 'flex', flexDirection: 'column'}}>
          <Box style={{display: 'flex', flexDirection: 'column'}}>
            {!isLoading && !isSynced && (
              <Typography variant="subtitle1" style={schooxMsgStyles}>
                Training link not available. Please contact administrator.
              </Typography>
            )}
            {isLoading && <SchooxLoadingInProgress />}
            {!isLoading && isSynced && (
              <SchooxLoadingComplete handleToggleOnGoToTrainingSchooxPopup={handleToggleOnGoToTrainingSchooxPopup} />
            )}
          </Box>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export const SchooxLoadingInProgress = () => {
  const ellipseStyles = useEllipseStyles();
  return (
    <Box>
      <Typography variant="subtitle1" style={schooxMsgStyles}>
        Please wait while we securely sync your training resources to your profile. This may take several minutes. You
        can continue to work in MyAccess while syncing.
      </Typography>
      <Box className={ellipseStyles.container}>
        <Box className={ellipseStyles.ellipse}></Box>
      </Box>
    </Box>
  );
};

type SchooxProps = {
  handleToggleOnGoToTrainingSchooxPopup: () => void;
};
export const SchooxLoadingComplete = (props: SchooxProps) => {
  return (
    <Box>
      <Typography variant="subtitle1" style={schooxMsgStyles}>
        Thank you for your patience. Your training resources are now synched to your profile.
      </Typography>
      <Button
        style={{fontSize: '14px', width: 'max-content', marginTop: '1rem'}}
        onClick={() => props.handleToggleOnGoToTrainingSchooxPopup()}
        variant="contained"
        color="primary"
      >
        <strong>Go To Training</strong>
      </Button>
    </Box>
  );
};
